import { useQuery } from '@tanstack/react-query';
import { Firmware, OtaTaskProps, OtaTaskStatus } from '@ixicare/resources';
import React from 'react';

export const OTA_TASKS_QUERY_KEY = ['otaTasks'];

/** An update the device has not finished or failed: planning another one for the device replaces it. */
export const PENDING_STATUSES: OtaTaskStatus[] = [
  'PLANNED',
  'WAITING_FOR_DOWNLOAD',
  'DOWNLOADING',
  'WAITING_FOR_INSTALL',
  'INSTALLING',
];

// Finished updates are left out: the software version column already shows what the device runs.
const OPEN_STATUSES: OtaTaskStatus[] = [...PENDING_STATUSES, 'ERROR'];

export const useOpenOtaTasksByDevice = (siteUuid: string | undefined, enabled: boolean) => {
  const query = useQuery({
    queryKey: [...OTA_TASKS_QUERY_KEY, siteUuid],
    queryFn: () => Firmware.getOtaTasks({ siteUuid, status: OPEN_STATUSES }),
    enabled: enabled && !!siteUuid,
    refetchInterval: 60_000,
  });

  return React.useMemo(() => {
    const byDevice = new Map<number, OtaTaskProps>();
    // Newest first from the backend, so the first task seen per device is the current one.
    (query.data ?? []).forEach((task) => {
      if (task.deviceId != null && !byDevice.has(task.deviceId)) byDevice.set(task.deviceId, task);
    });
    return byDevice;
  }, [query.data]);
};
